// DO NOT EDIT THIS FILE !!!! GENERATED DURING BUILD TYPE : Ansible
export const DOL_VERSION='[production]7.1.1-11964(70d04e9cd4)-C26/01/2026-18:22:39-B26/01/2026-18:27:13' ;
export const DOL_VERSION_JSON = {
  dolVersion: "[production]7.1.1-11964(70d04e9cd4)-C26/01/2026-18:22:39-B26/01/2026-18:27:13",
  branch: "production",
  latestTag: "7.1.1",
  revCount: "11964",
  shortHash: "70d04e9cd4",
  longHash: "70d04e9cd45cdd715337474577fb5e058ecd03a0",
  dateCommit: "26/01/2026-18:22:39",
  dateBuild: "26/01/2026-18:27:13",
  buildType: "Ansible",
  } ;
